module.exports = __webpack_public_path__ + "static/media/new-profile-pic.59ff292c.png";